import { render } from "./ProjectPreviewInfo.vue?vue&type=template&id=2b7cc74f&scoped=true"
import script from "./ProjectPreviewInfo.vue?vue&type=script&lang=js"
export * from "./ProjectPreviewInfo.vue?vue&type=script&lang=js"

import "./ProjectPreviewInfo.vue?vue&type=style&index=0&id=2b7cc74f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7cc74f"]])

export default __exports__